import React, { useState } from 'react'
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { visionInsuranceDetailView } from '../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceAction';
import ExportButton from '../../../../../../itrust_common/components/others/ExportButton';

export default function VerifiedInfoView(props) {
  const { rpaDetailViewPopup } = props
  let defaultWidth = rpaDetailViewPopup.service === '2020source' ? 160 : 100;
  let zoomIntervals = 90;
  const dispatch = useDispatch()
  const [imageWidth, setImageWidth] = useState(defaultWidth);
  const [zoomStatus, setZoomStatus] = useState('zoom-in')

  useEffect(() => {
    handleDraggableContainer()
  }, [])

  const handleDraggableContainer = () => {
    const container = document.querySelector(".draggable-container-1");
    const container1 = document.querySelector(".draggable-container");
    function onMouseDrag({ movementX, movementY }) {
      let getContainerStyle = window.getComputedStyle(container1);
      let leftValue = parseInt(getContainerStyle.left);
      let topValue = parseInt(getContainerStyle.top);
      container1.style.left = `${leftValue + movementX}px`;
      container1.style.top = `${topValue + movementY}px`;
    }
    container.addEventListener("mousedown", (e) => {
      container.addEventListener("mousemove", onMouseDrag);
    });
    document.addEventListener("mouseup", () => {
      container.removeEventListener("mousemove", onMouseDrag);
    });
  }

  const handleCloseRpaDetailView = () => {
    dispatch(visionInsuranceDetailView({ visible: false }))
  }

  const handleZoomInOut = () => {
    setImageWidth((prev) => {
      let newWidth;
      if (zoomStatus === 'zoom-in' && prev < 200) {
        newWidth = prev + zoomIntervals;
        if (newWidth >= 200) setZoomStatus('zoom-out');
      } else if (zoomStatus === 'zoom-out' && prev > 10) {
        newWidth = prev - zoomIntervals;
        if (newWidth <= defaultWidth) setZoomStatus('zoom-in');
      } else {
        newWidth = prev;
      }
      return newWidth;
    });
  };
  const isPdf =
    rpaDetailViewPopup?.content_type === "application/pdf";

  const reset = () => {
    imageWidth !== defaultWidth && setImageWidth(defaultWidth)
    setZoomStatus('zoom-in')
  }

  return (
    <div className='draggable-container bg-white border rounded shadow pb-5'>
      <div className='font-size-24 px-3 bg-white draggable-container-1 d-flex justify-content-between align-items-center py-5 draggable-container-header border-bottom'>
        <span className='font-size-20 ml-3 font-weight-500'>
          Click here to move!
        </span>
        {isPdf ? <div className='d-flex align-items-center mr-3'>
          {rpaDetailViewPopup.file_url && <a href={`${rpaDetailViewPopup.file_url}`} target='_blank' className='btn btn-primary mr-4 border' onClick={reset}>Print</a>}
          {imageWidth !== defaultWidth && <button className='btn btn-primary mr-4 border' onClick={reset}>Reset</button>}
          {rpaDetailViewPopup.file_url && <a href={`${rpaDetailViewPopup.file_url}`} target='_blank' className='btn btn-primary mr-4 border' onClick={reset}>Open in new window</a>}
          <span className='pointer text-primary' onClick={handleCloseRpaDetailView}><i className="las la-times-circle ml-3"></i></span>
        </div> :
          <div className='d-flex align-items-center mr-3'>

            <ExportButton label="Print" className='btn btn-primary mr-4' path={`/v1/add_ons/rpa/vision_insurance/logs/${rpaDetailViewPopup.id}/print`} params={{}} />
            {imageWidth !== defaultWidth && <button className='btn btn-primary mr-4 border' onClick={reset}>Reset</button>}
            {rpaDetailViewPopup.file_url && <a href={`${rpaDetailViewPopup.file_url}`} target='_blank' className='btn btn-primary mr-4 border' onClick={reset}>Open in new window</a>}
            <span className='pointer text-primary' onClick={handleCloseRpaDetailView}><i className="las la-times-circle ml-3"></i></span>
          </div>}
      </div>
      <div
        className={`py-5 px-4 d-flex align-items-center ${imageWidth === defaultWidth && 'justify-content-center'
          }`}
      >
        {rpaDetailViewPopup.file_url ? (
          isPdf ? (
            <iframe
              src={`${rpaDetailViewPopup.file_url}#toolbar=0&navpanes=0&scrollbar=0`}
              width="100%"
              height="500px"
              style={{ border: "none" }}
            />
          ) : (
            <img
              src={rpaDetailViewPopup.file_url}
              style={{ minWidth: `${imageWidth}%`, cursor: zoomStatus }}
            />
          )
        ) : (
          <p className="text-center font-size-24">Not Found</p>
        )}
      </div>
    </div>

  )
}
